module.exports = __webpack_public_path__ + "img/fi-rr-shield.663dde15.svg";